export const ADMIN_CONSENT_STATE_STORAGE_KEY = 'application-insights-consent-state';

export function createAdminConsentState(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  let binary = '';
  bytes.forEach(byte => { binary += String.fromCharCode(byte); });
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function matchesAdminConsentState(expectedState: string | null, returnedState: string): boolean {
  return expectedState !== null && returnedState === expectedState;
}